import { z } from "zod";
import { InnoveraCompanySchema } from "../portfolio-companies/portfolio-companies.schemas";

export const FounderRevisionsByIdSchema = z.object({
  founderRevisionId: z.coerce.number()
});

export const QueryFounderRevisionsPaginatedSchema = z.object({
  page: z.coerce.number().default(1),
  limit: z.coerce.number().default(10)
});

export const GetFounderRevisionSchema = z.object({
  canBePublished: z.boolean(),
  lastPublishedAt: z.coerce.date().nullable(),
  id: z.number(),
  companyId: z.number(),
  founderId: z.number(),
  name: z.string().nullable(),
  website: z.string().nullable(),
  description: z.string().nullable(),
  headline: z.string().nullable(),
  companyData: InnoveraCompanySchema.extend({
    harmonicInvestors: z.array(z.any()).optional().default([])
  }),
  phone: z.string().nullable(),
  email: z.string().nullable(),
  linkedInUrl: z.string().nullable(),
  facebookUrl: z.string().nullable(),
  twitterUrl: z.string().nullable(),
  solutionDescription: z.string().nullable(),
  marketDescription: z.string().nullable(),
  logoUrl: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),

  employees: z
    .array(
      z.object({
        employeeId: z.string(),
        firstName: z.string(),
        lastName: z.string().nullable(),
        title: z.string().nullable(),
        linkedInUrl: z.string().nullable(),
        imageUrl: z.string().nullable(),
        bio: z.string().nullable(),
        rank: z.number(),
        isFounder: z.boolean()
      })
    )
    .optional()
    .default([])
});

export const EmployeeListSchema = z.array(
  z.object({
    employeeId: z.string().optional(),
    firstName: z.string(),
    lastName: z.string().nullable(),
    title: z.string().nullable().optional(),
    linkedInUrl: z.string().nullable().optional(),
    imageUrl: z.string().nullable().optional(),
    bio: z.string().nullable().optional(),
    rank: z.number().min(0).default(0),
    isFounder: z.boolean().default(false),
    base64Image: z.string().optional()
  })
);

export type TGetFounderRevision = z.infer<typeof GetFounderRevisionSchema>;

export const PatchableFounderRevisionSchema = z.object({
  name: z.string().nullish(),
  description: z.string().nullish(),
  logoUrl: z.string().url().nullish(),
  city: z.string().nullish(),
  country: z.string().nullish(),
  state: z.string().nullish(),
  headline: z.string().nullish(),
  marketDescription: z.string().nullish(),
  solutionDescription: z.string().nullish(),
  phone: z.string().nullish(),
  email: z.string().email().nullish(),
  linkedInUrl: z.string().nullish(),
  facebookUrl: z.string().nullish(),
  twitterUrl: z.string().nullish()
});

export type PatchableFounderRevision = z.infer<typeof PatchableFounderRevisionSchema>;

export const WebsiteUpdateRequestSchema = z.object({
  desiredWebsite: z.string().min(1, "Desired changes are required"),
  additionalNotes: z.string().optional()
});

export type WebsiteUpdateRequest = z.infer<typeof WebsiteUpdateRequestSchema>;

export const ErrorReportSchema = z.object({
  errorType: z.enum(["Technical", "ContentRelated", "Other"]),
  description: z.string().min(1, "Description is required"),
  screenshotUrl: z.string().url().optional(),
  additionalInfo: z.string().optional()
});

export type ErrorReport = z.infer<typeof ErrorReportSchema>;
export const PostFounderAddedCompetitorsRevisionSchema = z.object({
  competitorIds: z.array(z.coerce.number())
});

export const PostCreateFounderCompetitorSchema = z.object({
  name: z.string(),
  website: z.string(),
  linkedinUrl: z.string().optional()
});
